module.exports = __webpack_public_path__ + "img/video-play.9b737958.svg";